import React from 'react';
import { OmFormInputWrapper, OmTextArea, OmFormError } from '@om/component-library-react';

const OmTextAreaWrapper = ({
    id,
    formId,
    slot,
    name,
    validationDelay = 0,
    showValidation = true,
    onShowingValidation,
    onTextAreaBlur,
    onPersist,
    reduxValue,
    hintText,
    label,
    labelAlwaysShow,
    placeholder,
    placeholderAsLabel = true,
    rows = 3,
    size = 'full',
    align = 'left',
    maxLength = 256,
    required = true,
    disabled,
    isResizable,
    wrap = 'soft',
    readOnly,
    useDisplayValue,
}) => {
    const determineValue = () => {
        if (useDisplayValue) {
            return reduxValue && reduxValue.displayValue;
        }
        return reduxValue && reduxValue.value;
    };

    return (
        <OmFormInputWrapper id={id} slot={slot} size={size} align={align}>
            <OmTextArea
                slot="input"
                formId={formId}
                name={name}
                hintText={hintText}
                label={label}
                labelAlwaysShow={labelAlwaysShow}
                placeholder={placeholder}
                placeholderAsLabel={placeholderAsLabel}
                rows={rows}
                size="full"
                align={align}
                maxlength={maxLength}
                required={required}
                isResizable={isResizable}
                wrap={wrap}
                readOnly={readOnly}
                validationDelay={validationDelay}
                showValidation={showValidation}
                onShowingValidation={(e) => onShowingValidation && onShowingValidation(e.detail)}
                onTextAreaBlur={(e) => onTextAreaBlur && onTextAreaBlur(e.detail)}
                onPersist={(e) => onPersist && onPersist(e.detail)}
                value={determineValue()}
                state={disabled ? 'disabled' : reduxValue && reduxValue.status}
            />
            {reduxValue && reduxValue.error && showValidation && (
                <OmFormError slot="error" message={reduxValue.error} />
            )}
        </OmFormInputWrapper>
    );
};

export default OmTextAreaWrapper;
